module.exports = __webpack_public_path__ + "static/media/3.ec96a5b5.png";